import { Payment } from './payments.model';

export interface PaymentBatchPayload {
  batchName: string; // required, maxLength: 100
  paymentDate: string; // required, DateOnly ISO string
  timesheetIds: string[]; // required, GUID[]
  paymentProcessor?: string; // optional, maxLength: 50
}

export interface PaymentBatch {
  createdAt: string;
  updatedAt: string;
  id: string;
  batchName: string;
  paymentDate: string;
  totalAmount: number;
  paymentCount: number;
  status: PaymentBatchStatus;
  paymentProcessor: string | null;
  processedAt: string | null;
  createdByName: string;
  payments: Payment[];
}

export enum PaymentBatchStatus {
  Processing = 'Processing',
  Completed = 'Completed',
  Failed = 'Failed',
  Draft = 'Draft',
  Pending = 'Pending',
  Cancelled = 'Cancelled'
}
